import React, { useState } from 'react';
import { IoCloseCircleSharp } from "react-icons/io5";
import { MdMailOutline } from "react-icons/md";
import { FaUser } from "react-icons/fa";
import { FaMobileRetro } from "react-icons/fa6";
import { BsBuildingsFill } from "react-icons/bs";
import { RiLockPasswordFill } from "react-icons/ri"
import { TbMapPinCode } from "react-icons/tb";
import { useDispatch } from 'react-redux';
import { setModal } from '../../redux/slice/Slice';
import { endpoints } from '../../api/endpoints';
import {
  faEye,
  faEyeSlash,
} from "@fortawesome/free-solid-svg-icons";
import toast from 'react-hot-toast';
import Api_Instance from '../../api/Api_Instance';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

const Popup = ({ isModalOpen, closeModal }) => {
  const dispatch = useDispatch();
  const api = Api_Instance.unAuth();
  const [showPassword, setShowPassword] = useState(false);
  const initialFormValues = {
    name: '',
    email: '',
    mobile: '',
    company_name: '',
    city: '',
    password: '',
    terms: false,
    role: "franchiser",
    direct_lead: true,
  }
  // Form state
  const [formData, setFormData] = useState({
    name: '',
    password: '',
    email: '',
    mobile: '',
    company_name: '',
    city: '',
    terms: false,
    role: "franchiser",
    direct_lead: true,
  });

  // Error state
  const [errors, setErrors] = useState({});

  // Handle input change
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value,
    });
    const fieldError = validate({ [name]: value })[name];
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: fieldError,
    }));
  };

  // Validation function
  const validate = () => {
    const newErrors = {};

    if (!formData.name) {
      newErrors.name = 'Name is required';
    }
    if (!formData.password) {
      newErrors.password = 'password is required';
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!formData.email || !emailRegex.test(formData.email)) {
      newErrors.email = 'Email is required';
    }

    const mobileRegex = /^[6-9]\d{9}$/;
    if (!formData.mobile || !mobileRegex.test(formData.mobile)) {
      newErrors.mobile = 'Mobile number is required';
    }

    if (!formData.company_name) {
      newErrors.company_name = 'Company name is required';
    }

    if (!formData.city) {
      newErrors.city = 'City is required';
    }

    // if (!formData.terms) {
    //   newErrors.terms = 'You must agree to the terms';
    // }

    return newErrors;
  };

  // Handle form submission
  const handleSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = validate();

    if (Object.keys(validationErrors).length === 0) {
      try {
        const response = await api("POST", endpoints.SIGNUP_API, formData);
        setFormData(initialFormValues)
        if (response.data.message) {
          toast.success(response.data.message);
          closeModal()
        }
        return response?.data?.data?.user_id;
      } catch (error) {
        const errorResponse = error.response?.data;
        if (errorResponse) {
          toast.error(errorResponse.message || "An error occurred");
        } else {
          toast.error(error.message || "An unknown error occurred");
        }
      }

    } else {
      setErrors(validationErrors);
    }
  };
  const handleBlur = (e) => {
    const { name, value } = e.target;
    const validationErrors = validate({
      ...formData,
      [name]: value,
    });
    setErrors(validationErrors);
  };
  return (
    <>
      {isModalOpen && (
        <>
          <section
            className={`fixed inset-0 z-40 ${isModalOpen ? 'bg-black bg-opacity-75' : ''}`}
            onClick={closeModal}
          ></section>
          <section className="fixed top-36 left-1/2 transform -translate-x-1/2 bg-white z-50 p-8 w-3/4 max-w-md rounded-lg border">
            <div className="modalWrapper mb-4">
              <h2 className="text-xl mt-4 mb-2 text-center font-semibold">Free Advice - Ask Our Experts</h2>
              <p className="font-semibold text-center">Expand My Brand</p>
            </div>
            <div>
              <form onSubmit={handleSubmit}>
                <div className="!border-[1px] mt-3 flex items-center rounded-[5px]">
                  <FaUser className="text-[18px] mx-2" />
                  <input
                    type="text"
                    name="name"
                    placeholder="Enter Name"
                    maxLength={25}
                    value={formData.name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="p-2 border border-gray-300 w-full focus:outline-none"
                  />
                </div>
                {errors.name && <p className="text-[red] text-xs">{errors.name}</p>}

                <div className="!border-[1px] mt-3 flex items-center rounded-[5px]">
                  <MdMailOutline className="text-[20px] mx-2" />
                  <input
                    type="email"
                    name="email"
                    placeholder="Enter Email"
                    maxLength={25}
                    value={formData.email}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="p-2 border border-gray-300 w-full focus:outline-none"
                  />
                </div>
                {errors.email && <p className="text-[red] text-xs">{errors.email}</p>}
                <div className="relative !border-[1px] mt-3 flex items-center rounded-[5px]">
                  <RiLockPasswordFill className="text-[18px] mx-2" />
                  <input
                    type={showPassword ? "text" : "password"}
                    name="password"
                    placeholder="Enter Password"
                    maxLength={35}
                    value={formData.password}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="p-2 border border-gray-300 w-full focus:outline-none"
                  />
                  <button
                    type="button"
                    className="absolute top-[10px] right-[10px] text-gray-500"
                    onClick={() => setShowPassword((prev) => !prev)}
                  >
                    <FontAwesomeIcon
                      icon={showPassword ? faEye :  faEyeSlash}
                      size="sm"
                    />
                  </button>
                </div>
                {errors.password && <p className="text-[red] text-xs">{errors.password}</p>}
                <div className="!border-[1px] mt-3 flex items-center rounded-[5px]">
                  <FaMobileRetro className="text-[20px] mx-2" />
                  <input
                    type="text"
                    name="mobile"
                    placeholder="Enter mobile Number"
                    maxLength={10}
                    value={formData.mobile}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="p-2 border border-gray-300 w-full focus:outline-none"
                  />
                </div>
                {errors.mobile && <p className="text-[red]  text-xs">{errors.mobile}</p>}

                <div className="!border-[1px] mt-3 flex items-center rounded-[5px]">
                  <BsBuildingsFill className="text-[20px] mx-2" />
                  <input
                    type="text"
                    name="company_name"
                    placeholder="Enter Company name"
                    maxLength={25}
                    value={formData.company_name}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="p-2 border border-gray-300 w-full focus:outline-none"
                  />
                </div>
                {errors.company_name && <p className="text-[red]  text-xs">{errors.company_name}</p>}

                <div className="!border-[1px] mt-3 flex items-center rounded-[5px]">
                  <TbMapPinCode className="text-[20px] mx-2" />
                  <input
                    type="text"
                    name="city"
                    placeholder="Enter City"
                    maxLength={25}
                    value={formData.city}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className="p-2 border border-gray-300 w-full focus:outline-none"
                  />
                </div>
                {errors.city && <p className="text-[red]  text-xs">{errors.city}</p>}

                <div className="mt-2">
                  <input
                    type="checkbox"
                    name="terms"
                    checked={formData.terms}
                    onChange={handleChange}
                  />
                  <label className="ps-2 font-semibold text-sm">I agree to the Terms & Conditions</label>
                </div>
                {errors.terms && <p className="text-[red]  text-xs">{errors.terms}</p>}

                <div className="text-center mx-auto mt-4 mb-3">
                  <button type="submit" className="border rounded-lg px-10 py-2 text-white bg-[#0096c4] font-medium mx-auto">
                    Ask your expert
                  </button>
                </div>
              </form>
            </div>
            <button
              className="absolute top-4 right-4 text-gray-700 cursor-pointer"
              onClick={() => {
                closeModal();
                dispatch(setModal(false));
              }}
            >
              <IoCloseCircleSharp className="text-[30px]" />
            </button>
          </section>
        </>
      )}
    </>
  );
};

export default Popup;
